/**
 * Mock Data for Lite CMS Demo
 * All mock content is centralized here for easy management.
 */

export const MOCK_BRAND = {
    BrandID: 'lite-brand-001',
    BrandName: 'My Workspace',
};

export const MOCK_BRANCH = {
    BranchID: 'lite-branch-001',
    BranchName: 'Main Location',
};

export const MOCK_SCREEN = {
    ScreenID: 'lite-screen-001',
    ScreenName: 'Lobby Display',
    Status: 'Online',
    Resolution: '1920x1080',
    LastSeen: '2 minutes ago',
    Timezone: 'Asia/Bangkok',
    AppVersion: 'v3.2.1',
};

export const MOCK_LIBRARY = [
    {
        id: 'lib-001',
        type: 'image',
        name: 'Summer_Promo_Banner.jpg',
        url: 'https://images.unsplash.com/photo-1557682250-33bd709cbe85?w=800',
        previewUrl: 'https://images.unsplash.com/photo-1557682250-33bd709cbe85?w=400',
        duration: '10s',
        size: '2.4 MB',
        uploadedAt: '2 hours ago',
    },
    {
        id: 'lib-002',
        type: 'video',
        name: 'Product_Showcase.mp4',
        url: 'https://test-videos.co.uk/vids/bigbuckbunny/mp4/h264/360/Big_Buck_Bunny_360_10s_1MB.mp4',
        previewUrl: 'https://images.unsplash.com/photo-1611532736597-de2d4265fba3?w=400',
        duration: '15s',
        size: '12.8 MB',
        uploadedAt: '5 hours ago',
    },
    {
        id: 'lib-003',
        type: 'image',
        name: 'Store_Hours_Update.png',
        url: 'https://images.unsplash.com/photo-1557682224-5b8590cd9ec5?w=800',
        previewUrl: 'https://images.unsplash.com/photo-1557682224-5b8590cd9ec5?w=400',
        duration: '8s',
        size: '1.1 MB',
        uploadedAt: '1 day ago',
    },
    {
        id: 'lib-004',
        type: 'image',
        name: 'Welcome_Greeting.jpg',
        url: 'https://images.unsplash.com/photo-1618005182384-a83a8bd57fbe?w=800',
        previewUrl: 'https://images.unsplash.com/photo-1618005182384-a83a8bd57fbe?w=400',
        duration: '10s',
        size: '3.2 MB',
        uploadedAt: '2 days ago',
    },
    {
        id: 'lib-005',
        type: 'video',
        name: 'Holiday_Sale_Video.mp4',
        url: 'https://test-videos.co.uk/vids/bigbuckbunny/mp4/h264/360/Big_Buck_Bunny_360_10s_1MB.mp4',
        previewUrl: 'https://images.unsplash.com/photo-1607083206869-4c7672e72a8a?w=400',
        duration: '30s',
        size: '24.5 MB',
        uploadedAt: '3 days ago',
    },
    {
        id: 'lib-006',
        type: 'image',
        name: 'Brand_Logo_Slide.png',
        url: 'https://images.unsplash.com/photo-1579546929518-9e396f3cc809?w=800',
        previewUrl: 'https://images.unsplash.com/photo-1579546929518-9e396f3cc809?w=400',
        duration: '5s',
        size: '0.8 MB',
        uploadedAt: '1 week ago',
    },
];

// Content items already in the active loop
export const MOCK_PLAYLIST = [
    {
        id: 'pl-001',
        type: 'image',
        name: 'Summer_Promo_Banner.jpg',
        previewUrl: 'https://images.unsplash.com/photo-1557682250-33bd709cbe85?w=400',
        duration: '10s',
        size: '2.4 MB',
    },
    {
        id: 'pl-002',
        type: 'video',
        name: 'Product_Showcase.mp4',
        previewUrl: 'https://images.unsplash.com/photo-1611532736597-de2d4265fba3?w=400',
        duration: '15s',
        size: '12.8 MB',
    },
    {
        id: 'pl-003',
        type: 'image',
        name: 'Welcome_Greeting.jpg',
        previewUrl: 'https://images.unsplash.com/photo-1618005182384-a83a8bd57fbe?w=400',
        duration: '10s',
        size: '3.2 MB',
    },
];

export const SCREEN_RATIOS = [
    { label: '16:9', value: '16/9', description: 'Landscape TV' },
    { label: '9:16', value: '9/16', description: 'Portrait' },
    { label: '4:3', value: '4/3', description: 'Classic' },
    { label: '1:1', value: '1/1', description: 'Square' },
];
